// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const getSanctionsBySupplierId = (supplierId) =>
  api().get(`data/cache/sanctions/output/latest/${supplierId}.json`);

export default getSanctionsBySupplierId;
